import { useMemo } from 'react';

import { AUDIO, IMAGE, STOCK_CLIP, TEXT_OVERLAY, VIDEO } from '@/constants';
import { ReviewComponent } from '@/pages/Event/components/Review';
import {
  ThemeProp,
  TributeVideoAsset,
  TributeVideoOptionsType,
  UpdateCreateTributeVideoPayload
} from '@/types';

type ReviewProps = {
  theme?: ThemeProp;
  assets: TributeVideoAsset[];
  tributeVideoData: UpdateCreateTributeVideoPayload;
  relatedUsersCanGenerate?: boolean;
  hasMusicStep?: boolean;
  titleText: string | undefined;
  deceasedNameText: string | undefined;
  birthDeathText: string | undefined;
  tributeVideoOptions: TributeVideoOptionsType;
};

export const Review = ({
  theme,
  assets,
  tributeVideoData,
  relatedUsersCanGenerate,
  hasMusicStep,
  titleText,
  deceasedNameText,
  birthDeathText,
  tributeVideoOptions
}: ReviewProps) => {
  const music = useMemo(() => assets.filter((a) => a.asset.assetType === AUDIO), [assets]);

  const photos = useMemo(
    () =>
      assets
        .filter(
          (a) =>
            a.asset.assetType === IMAGE ||
            a.asset.assetType === VIDEO ||
            a.asset.assetType === STOCK_CLIP ||
            a.asset.assetType === TEXT_OVERLAY
        )
        .sort((a, b) => a.order - b.order),
    [assets]
  );

  return (
    <div className='flex size-full flex-col'>
      <ReviewComponent
        photos={photos}
        music={music}
        theme={theme}
        tributeVideoData={tributeVideoData}
        assets={assets}
        titleText={titleText}
        deceasedNameText={deceasedNameText}
        birthDeathText={birthDeathText}
        relatedUsersCanGenerate={relatedUsersCanGenerate}
        hasMusicStep={hasMusicStep}
        tributeVideoOptions={tributeVideoOptions}
      />
    </div>
  );
};
